export default __webpack_public_path__ + "static/media/complementary--end-of-road-works--g1.92d44f56.png";